
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";

interface VerseHeaderProps {
  backgroundStyle: React.CSSProperties;
}

export function VerseHeader({ backgroundStyle }: VerseHeaderProps) {
  const { branding } = useChurchBranding();

  return (
    <div className="w-full px-8 flex flex-col items-start pt-4 pb-6 bg-gradient-to-b from-[rgba(26,31,44,0.85)] to-transparent">
      <div className="flex items-center gap-2">
        <img 
          src={branding?.logoUrl || "/lovable-uploads/97cec83c-b4fa-48c3-a12a-a678346efa1f.png"} 
          alt={branding?.churchName || "Grace Awakens"} 
          className="h-16 drop-shadow-[0_0_15px_rgba(255,255,255,0.5)] transition-all duration-300 hover:drop-shadow-[0_0_25px_rgba(255,255,255,0.7)]" 
        />
        
        {branding?.churchName && (
          <div className="flex flex-col">
            <span className="text-white text-sm font-light drop-shadow-[0_0_10px_rgba(0,0,0,0.7)]">
              Welcome to
            </span>
            <h2 className="text-white text-xl font-semibold drop-shadow-[0_0_10px_rgba(0,0,0,0.7)]">
              {branding.churchName}
            </h2>
          </div>
        )}
      </div>
    </div>
  );
}
